import Medico01 from '../views/wizards/Medico01.vue'
import Medico02 from '../views/wizards/Medico02.vue'
import Medico03 from '../views/wizards/Medico03.vue'
import PacienteCita01 from '../views/wizards/PacienteCita01.vue'
import PacienteCita02 from '../views/wizards/PacienteCita02.vue'
import PacienteCita03 from '../views/wizards/PacienteCita03.vue'
import UsuarioAdm01 from '../views/wizards/UsuarioAdm01.vue'
import UsuarioAdm02 from '../views/wizards/UsuarioAdm02.vue'
import UsuarioAdm03 from '../views/wizards/UsuarioAdm03.vue'
import GenerarFechasCitas from '../views/utils/GenerarFechasCitas.vue'

export default [
  {
    path: '/medico01/:p_idpersona',
    name: 'Medico01',
    component: Medico01
  },
  {
    path: '/medico02/:p_idpersona',
    name: 'Medico02',
    component: Medico02
  },
  {
    path: '/medico03/:p_idmedico',
    name: 'Medico03',
    component: Medico03
  },
  {
    path: '/pacientecita01/:p_idpersona',
    name: 'PacienteCita01',
    component: PacienteCita01
  },
  {
    path: '/pacientecita02/:p_idpersona/:p_idespecialidad/:p_idmedico',
    name: 'PacienteCita02',
    component: PacienteCita02
  },    
  {
    path: '/pacientecita03/:p_idcita',
    name: 'PacienteCita03',
    component: PacienteCita03
  },
  {
    path: '/usuarioadm01',
    name: 'UsuarioAdm01',
    component: UsuarioAdm01
  },
  {
    path: '/usuarioadm02/:p_idpersona',
    name: 'UsuarioAdm02',
    component:UsuarioAdm02
  },
  {
    path: '/usuarioadm03/:p_idmedico',
    name: 'UsuarioAdm03',
    component: UsuarioAdm03
  },
  {
    path: '/generarfechascitas',
    name: 'GenerarFechasCitas',
    component: GenerarFechasCitas
  },
];